import { UPDATE_QUOTE_SERVICES } from "Redux/ActionTypes/QuoteServices";

export function updateQuoteServices(event: any, key: string) {
  return {
    type: UPDATE_QUOTE_SERVICES,
    event,
    key
  };
}